import { Navigate, Outlet, PathRouteProps, Route, RouteProps, useLocation } from "react-router-dom";
import { useAuthContext } from "./AuthStateProvider";
import Login from "../pages/login/Login";
import { RouteName } from "../AppRoutes";

export interface ProtectedRouteProps extends Omit<PathRouteProps, 'element'> {
    name?: RouteName
    children?: React.ReactNode;
    roles: string[]
    /** If true, the route renders for anyone — no auth required. Roles/auth are ignored. */
    isPublic?: boolean
}

const ProtectedContent: React.FC<ProtectedRouteProps> = ({ name, children, roles, isPublic, ...rest }) => {
  const { isAuthenticated, user, loading } = useAuthContext();

  // While the initial /auth/me is in flight, render nothing so we don't flash
  // <Login/> for an authenticated user on a hard reload.
  if (loading) return null;

  if (isPublic) {
    if (children) return <>{children}</>;
    return <Outlet/>;
  }

  const hasAccess =
    (
        (!roles || roles.length > 0) &&
        isAuthenticated &&
        user &&
        (!roles || roles.includes(user?.role))
    ) ||
    (
        roles && roles.length === 0 && (!isAuthenticated || !user)
    );

    if (!hasAccess) {
        return <Login />
    }

    if (children) {
        return <>{children}</>;
    }

    return <Outlet/>;
};

export default ProtectedContent;